module.exports = __webpack_public_path__ + "static/media/ExpandArrow.b9b96137.svg";